export enum LoadStatus {
  NOT_LOADED,
  LOADING,
  LOADED,
}
